import { enableProdMode, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { ApiConService } from './app/shared/api-con.service';
import { DashboardService } from './app/dashboard/dashboard.service';
import { EsriLoadService } from './app/shared/esri-load-control.service';
import { BoxListTruckService } from './app/box-list-truck/box-list-truck.service';
import { BoxInfoJourneyService } from './app/box-info-journey/box-info-journey.service';
import { BoxInfoRouterService } from './app/box-info-router/box-info-router.service';
import { BoxInfoTruckService } from './app/box-info-truck/box-info-truck.service';
import { ControlStatusService } from './app/shared/control-status.service';
import { HeaderFilterService } from './app/header-filter/header-filter.service';
import { GraphicService } from './app/shared/graphic.service';
import { RouteService } from './app/shared/route.service';
import { BoxInfoAlertService } from './app/box-info-alert/box-info-alert.service';
import { MainHeaderTruckService } from './app/main-header-truck/main-header-truck.service';
import { BoxHistoricoAcoesService } from './app/box-historico-acoes/box-historico-acoes.service';
import { IconService } from './app/shared/icon.service';
import { PopupConfigService } from './app/popup-config/popup-config.service';
import { TokenService } from './app/popup-tokens/token.service';
import { CurrencyPipe } from '@angular/common';
import { Util } from './app/shared/Util';
import { CookieService } from 'ngx-cookie-service';
import { TruckInfoService } from './app/truck-info/truck-info.service';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { GridsterModule } from 'angular-gridster2';
import { ColorPickerDirective, ColorPickerComponent } from 'ngx-color-picker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ToastNoAnimationModule } from 'ngx-toastr';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, NgbModule, HttpClientModule, FormsModule, ReactiveFormsModule, Ng2GoogleChartsModule, GridsterModule, ColorPickerDirective, ColorPickerComponent, MatFormFieldModule, MatSelectModule, ToastNoAnimationModule.forRoot({ preventDuplicates: true, })),
        ApiConService,
        DashboardService,
        EsriLoadService,
        BoxListTruckService,
        BoxInfoJourneyService,
        BoxInfoRouterService,
        BoxInfoTruckService,
        ControlStatusService,
        HeaderFilterService,
        GraphicService,
        RouteService,
        BoxInfoAlertService,
        MainHeaderTruckService,
        BoxHistoricoAcoesService,
        IconService,
        PopupConfigService,
        TokenService,
        CurrencyPipe,
        Util,
        CookieService,
        TruckInfoService,
        { provide: LOCALE_ID, useValue: "pt-BR" },
        provideAnimations()
    ]
});
